export class Author {
    public id: number;
    public lastName: string;
    public firstName: string;

    public static toJSON(author: Author): AuthorDTO {
        return <AuthorDTO> {
            firstName: author.firstName,
            lastName: author.lastName,
        }
    }
}

export interface AuthorDTO {
    firstName: string,
    lastName: string
}

